import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useOutlook } from "./useOutlook";

// If user change current reading email in payable invoice detail page, redirect to activities page
export function useRedirectToActivities(emailAddress: string | null) {
  const navigate = useNavigate();
  const { isInReadMode } = useOutlook();
  const prevEmailAddress = useRef<string | null>(null);

  useEffect(() => {
    if (prevEmailAddress.current && prevEmailAddress.current !== emailAddress) {
      if (!isInReadMode) {
        navigate("/activities");
      } else {
        navigate("/contacts");
      }
    }
    prevEmailAddress.current = emailAddress;
  }, [emailAddress, isInReadMode]);
}
